module.exports = __webpack_public_path__ + "img/bw.980ba38b.svg";